"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconHourglass = function SvgIconHourglass(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "hourglass icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Hourglass Icon'), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "nonzero",
    d: "M37.125 4h-26.25C9.839 4 9 4.84 9 5.875v1.25C9 8.161 9.84 9 10.875 9c0 7.107 3.986 13.104 9.44 15-5.454 1.896-9.44 7.893-9.44 15C9.839 39 9 39.84 9 40.875v1.25C9 43.161 9.84 44 10.875 44h26.25C38.161 44 39 43.16 39 42.125v-1.25C39 39.839 38.16 39 37.125 39c0-7.107-3.986-13.104-9.44-15 5.454-1.896 9.44-7.893 9.44-15C38.161 9 39 8.16 39 7.125v-1.25C39 4.839 38.16 4 37.125 4zM31.26 34H16.74c1.333-3.656 4.07-6.25 7.26-6.25 3.19 0 5.927 2.593 7.26 6.25zm.001-20h-14.52a14.657 14.657 0 01-.866-5h16.25c0 1.782-.311 3.483-.864 5z"
  }));
};

var _default = SvgIconHourglass;
exports.default = _default;